<div class="link-component">
    <app-layout-control>
        <app-control-label top [control]="control" [caption]="caption()" />
        <dx-radio-group #dx
            [dataSource]="dataSource()"
            [itemTemplate]="itemTemplate()? 'itemTemplate' : 'item'"
            [valueExpr]="valueExpr()"
            [displayExpr]="displayExpr()"
            [value]="value()"
            (onBlur)="onTouched()"
            (onValueChanged)="onValueChanged($event)">

            <div *dxTemplate="let data of 'itemTemplate'">
                <ng-template [ngTemplateOutlet]="itemTemplate()" [ngTemplateOutletContext]="{ $implicit: data }"></ng-template>
            </div>
        </dx-radio-group>
        <app-control-supporting-text bottom [control]="control" [controlName]="caption()" [helpText]="helpText()" [isValid]="isValid" />
    </app-layout-control>
</div>